import ProductShape from '../../shapes/product';
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import { classes } from './styles/table';
import ProductIDCellComponent from "../common/product-id-cell";
import { Button } from 'reactstrap';
import { withPermissions } from '../../services/permissions';

// So we don't leak somewhere
const SYMBOL_PERMISSION = Symbol('Permission');

class ApplicationsView extends React.Component {

  state = {

  };

  constructor(props) {
    super(props);

    this.state.options = {
      context: {
        componentParent: this
      },
      localeText: {
        noRowsToShow: props.t('table.emptyMessage')
      },
      frameworkComponents: {
        ProductIDCellComponent
      },
      columnDefs: [
        {
          field: 'uuid',
          headerName: props.t('table.uuidHeader'),
          singleClickEdit: true
        },
        {
          field: 'package',
          headerName: props.t('table.packageHeader'),
          editable: true,
          singleClickEdit: true
        },
        {
          field: 'name',
          headerName: props.t('table.nameHeader'),
          cellRenderer: 'ProductIDCellComponent',
          editable: true,
          singleClickEdit: true
        }
      ],
      enableFilter: true,
      enableSorting: true,
      onGridReady: this.onGridReady
    }
  }

  onGridReady = ({ api }, subApi) => {
    this.gridApi = api;
    this.subGridApi = subApi;
  };

  onDeleteClicked = (event, action, { data: { actions: unused, ...data } }) => {
    const remove = () => {
      this.gridApi.updateRowData({
        remove: [
          data
        ]
      })
    };

    if (!data.uuid) {
      return remove();
    }

    return this.props.onDelete(data, remove);
  };

  onSaveClicked = (event, action, { data: { actions: unused, ...data } , node }) => {
    const setData = (newData) => {
      this.subGridApi.setNodeData(node, newData);
    };
    return this.props.onSave(data, setData);
  };

  onAddEmptyRow = () => {
    if (!this.gridApi) {
      return;
    }
    this.subGridApi.add({});
  };

  onViewPermissions = (event, action, { data: { actions: unused, ...data }}) => {
    return this.props.onPermissions(data);
  };

  onViewVersions = (event, action, { data: { actions: unused, ...data }}) => {
    return this.props.onVersions(data);
  };

  onViewInstances = (event, action, { data: { actions: unused, ...data }}) => {
    return this.props.onInstances(data);
  };

  render() {
    const { t, hasPermission } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <div />
          <h3>{t('table.header')}</h3>
          <div>
            <Button onClick={this.onAddEmptyRow}>Add</Button>
          </div>
        </div>
        <div
          className={`ag-theme-blue ${classes.table}`}
        >
          <AgGridReact
            name="applications"
            {...this.state.options}
            items={this.props.products}
            cleanActions={
              [
                {
                  [SYMBOL_PERMISSION]: 'View Application Permissions',
                  name: 'Permissions',
                  onClick: this.onViewPermissions
                },
                {
                  [SYMBOL_PERMISSION]: 'View Application Versions',
                  name: 'Versions',
                  onClick: this.onViewVersions
                },
                {
                  [SYMBOL_PERMISSION]: 'View Application Instances',
                  name: 'Instances',
                  onClick: this.onViewInstances
                },
                {
                  name: 'Delete',
                  onClick: this.onDeleteClicked
                }
              ]
                .filter(value => {
                  if (!value) {
                    return false;
                  }
                  return typeof value[SYMBOL_PERMISSION] !== 'string' || hasPermission(value[SYMBOL_PERMISSION]);
                })
            }
            dirtyActions={
              [
                {
                  name: 'Save',
                  onClick: this.onSaveClicked
                },
                {
                  name: 'Cancel',
                  revert: true
                }
              ]
                .filter(value => {
                  if (!value) {
                    return false;
                  }
                  return typeof value.permission !== 'string' || hasPermission(value.permission);
                })
            }
          />
        </div>
      </React.Fragment>
    )
  }

}

ApplicationsView.propTypes = {
  products: PropTypes.arrayOf(ProductShape).isRequired
};

export default translate(['product'])(withPermissions(ApplicationsView));



// WEBPACK FOOTER //
// ./src/views/applications/table.js